import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { Col, Container, Row } from "reactstrap";
import { Input, Button } from "antd";
import { toast } from "react-toastify";
import bcrypt from "bcryptjs";
import { error } from "../../Controllers/toast";

// declare type for the props
const OTPInput = ({ length = 6, onComplete, btnDisabled,setCode,code }) => {
  const inputRef = useRef(Array(length).fill(null));
  const [OTP, setOTP] = useState(Array(length).fill(""));

  // console.log(OTP , "is OTP")

  useEffect(() => {
    // Focus on the first input field when the component mounts
    if (inputRef.current[0]) {
      inputRef.current[0].focus();
    }
    if ("OTPCredential" in window) {
      const ac = new AbortController();

      navigator.credentials
        .get({
          otp: { transport: ["sms"] },
          signal: ac.signal,
        })
        .then((otp) => {
          // toast.info((otp.code))
          // if (bcrypt.compareSync(otp.code, code)) {
          //   // !props.register?success("احراز هویت باموفقیت انجام شد!"):console.log("");
          //   onComplete();
          //   // setBtnDisabled(false);
          // } 
          setOTP(otp.code);
          setCode(otp.code)
          ac.abort();
        })
        .catch((err) => {
          ac.abort();
          console.log(err);
        });
    }

    // if (send) {
    //   onComplete(OTP.toString());
    //   setSend(false);
    // }
  }, []);

  const handleTextChange = (input, index) => {
    const newPin = [...OTP];
    newPin[index] = input;
    setOTP(newPin);
    setCode(newPin.join(''))

    if (input.length === 1 && index < length - 1) {
      inputRef.current[index + 1].focus();
    }

    if (newPin.every((digit) => digit !== "")) {
      // console.log(newPin.join('') , "is input")
      handleSubmit(newPin.join(""));
    } 
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !OTP[index] && index > 0) {
      inputRef.current[index - 1].focus();
    }
  };

  const handleSubmit = (input) => {
    
    // toast.warning(input)
    if (bcrypt.compareSync(input, code)) {
      // !props.register?success("احراز هویت باموفقیت انجام شد!"):console.log("");
      onComplete();
      // setBtnDisabled(false);
    } else {
      error("کد وارد شده نامعتبر است!");
    }
    
   
  };

  return (
    <Container>
      <Row className="justify-content-center">
        <Col md="auto">
          <div className="d-flex justify-content-between ltr">
            {Array.from({ length }, (_, index) => (
              <Input
                disabled={btnDisabled}
                key={index}
                type="text"
                maxLength={1}
                value={OTP[index]}
                onChange={(e) => handleTextChange(e.target.value, index)}
                onKeyDown={(e) => handleKeyDown(e, index)}
                ref={(ref) => (inputRef.current[index] = ref)}
                style={{
                  width: "50px",
                  height: "50px",
                  marginRight: index === length - 1 ? "0" : "10px",
                  textAlign: "center",
                  fontSize: "24px",
                }}
              />
            ))}
          </div>
        </Col>
      </Row>
     
    </Container>
  );
};

OTPInput.propTypes = {
  length: PropTypes.number,
  onComplete: PropTypes.func.isRequired,
};

export default OTPInput;
